declare global {
  interface Window {
    webengage: {
      user: {
        setAttribute: (name: string, value: unknown) => void;
        login: (data: unknown) => void;
      };
      track: (eventName: string, properties?: Record<string, unknown>) => void;
      webpush: {
        prompt: () => void;
        isSubscribed: () => boolean;
      };
      options: (event: string, showPrompt: boolean) => void;
    };
    generateBrowserLink?: (openInBrowserLink: string) => string; // works on snapp native
  }
}

export type AddEventToWebengageType = (
  event: WEBENGAGE_EVENTS,
  data: Record<string, unknown>
) => void;

export type WebengageLoginType = () => {
  login: (guestUserPhone?: string | number) => void;
};

export type AddEventToDataLayerType = (
  event: DATA_LAYER_EVENTS,
  dataLayerData: Record<string, unknown>
) => void;

export enum WEBENGAGE_EVENTS {
  CITY_VISIT = "hotel-cityVisit",
  HOTEL_VISIT = "hotel-hotelVisit",
  CATEGORY_VISIT = "category-page-hotel",
  SIGN_UP = "Signup",
  SIMILAR_HOTELS = "hotel-similarHotels",
  PAY_BANNER_IMPRESSION = "pay_banner_impression",
  HOTEL_RESERVATION = "hotel-reservation",
  HOTEL_CONFIRM_INFO = "hotel-confirmInfo",
  HOTEL_CHECKOUT_COMPLETE = "hotel-checkOutComplete",
  HOTEL_FULFILLED = "hotel-fulfilled",
  HOTEL_TELE_SALE = "snapptrip-dh-tele-sales",
  HOTEL_TO_PAY = "hotel-toPay",
  IH_cityVisit = "IH-cityVisit",
  IH_hotelVisit = "IH-hotelVisit",
  IH_reservation = "IH_reservation",
  IH_confirmInfo = "IH-confirmInfo",
  IH_checkOutComplete = "IH-checkOutComplete",
  IH_Fulfilled = "IH-Fulfilled",

  TOUR_ST_SEARCH = "Tour_ST_Search",
  TOUR_ST_CHANGE_PACKAGE = "Tour_ST_Change_Package",
  TOUR_ST_SELECT_SOLUTION = "Tour_ST_Select_Solution",
  TOUR_ST_HOTEL_SELECTED = "Tour_ST_Hotel_Selected",
  TOUR_ST_HOTEL_DETAILS = "Tour_ST_Hotel_Details",
  TOUR_ST_HOTEL_DETAILS_LOCATION = "Tour_ST_Hotel_Details_Location",
  TOUR_ST_HOTEL_DETAILS_RATE_REVIEW = "Tour_ST_Hotel_Details_Rate&Review",
  TOUR_ST_HOTEL_DETAILS_FACILITIES = "Tour_ST_Hotel_Details_Facilities",
  TOUR_ST_TELESALES = "Tour_ST_TeleSales",
  TOUR_ST_SUGGESTION_CLICKED = "Tour_ST_Suggestion_clicked",
  TOUR_ST_SUGGESTED = "Tour_ST_Suggested",
  FLIGHT_INTL_PRICE_TABLE_LOADED = "IF_priceTableLoaded",
  TOUR_ST_PRICING_TABLE_CLICKED = "Tour_ST_Pricing_Table_Clicked",
  FLIGHT_INTL_SEARCH = "IF_search",
  FLIGHT_INTL_SELECT_SOLUTION = "IF_selectSolution",
  FLIGHT_INTL_EMPTY_SEARCH = "IF_empty_search",
  FLIGHT_INTL_PRICE_CALENDAR = "IF_priceCalendarLoaded",
  FLIGHT_INTL_VISA_SEARCH = "IF_visaSearch",
  FLIGHT_INTL_VISA_SUBMIT = "IF_visaSubmitted",
  FLIGHT_DOM_PRICE_TABLE_LOADED = "DF_priceTableLoaded",
  FLIGHT_DOM_SOLUTION_SELECTED = "DF_solution_selected",
  FLIGHT_DOM_RESULT_PAGE_VISITED = "DF_results_page_visited",
  FLIGHT_DOM_PRICE_CALENDAR = "DF_priceCalendarLoaded",

  HOTEL_SEARCH_CLICKED = "hotel-search-clicked",
  HOTEL_INTERNATIONAL_SEARCH_CLICKED = "IH-search-clicked",
  TOUR_SEARCH_CLICKED = "tour-search-clicked",
  TOUR_SEARCH_PHONE = "tour-search-phone",
  FLIGHT_DOM_SEARCH_INITIATED = "DF_search_clicked",
  FLIGHT_INTL_SEARCH_INITIATED = "IF_search_clicked",
  HOME_PAGE_LAND = "IF_homePageLanded",
  SEARCH = "hotel-search",
  VILLA_SEARCH_CLICKED = "villa-search-clicked",
  TRAIN_SEARCH = "train-search",
  BUS_SEARCH_CLICKED = "bus-search-clicked",
  BUS_INTL_SEARCH_CLICKED = "Ibus-search-clicked",
  BANNER_CLICKED = "banner_clicked"
}

export enum USER_TRACKING_EVENTS {
  APP_BANNER_SHOWED = "app_banner_showed",
  APP_BANNER_DISMISSED = "app_banner_dismissed",
  APP_BANNER_DOWNLOAD_CLICKED = "app_banner_download_clicked",
  VILLA_HOME_DESTINATION_CARD_CLICKED = "villa_home_destination_card_clicked",
  VILLA_HOME_CITY_FILTER_SELECTED = "villa_home_city_filter_selected",
  VILLA_HOME_SEE_MORE_CLICKED = "villa_home_see_more_clicked",
  VILLA_HOME_SECTION_VIEWED = "villa_home_section_viewed",
  VILLA_HOME_PROPERTY_CARD_CLICKED = "villa_home_property_card_clicked",
  VILLA_HOME_CATEGORY_CLICKED = "villa_home_category_clicked",
  VILLA_HOME_POPULAR_CITY_CLICKED = "villa_home_popular_city_clicked",
  FOOTER_CTA_CLICK = "footer_cta_click",
  VILLA_SPACES_SECTION_VIEWED = "villa_spaces_section_viewed",
  REVIEWS_SECTION_OPENED = "reviews_section_opened",
  REVIEWS_BOTTOM_CTA_VIEWED = "reviews_bottom_cta_viewed",
  SCROLL_TO_ROOM_SECTION = "scroll_to_room_section",
  AI_SUMMARY_COMMENTS = "ai_summary_comments",
  BADGE_FILTER_CLICKED = "badge_filter",
  EXPERIMENT_VIEWD = "experiment_viewed",
  CITY_PAGE_HOTEL_CARD_VIEW = "city_page_hotel_card_view",
  CITY_PAGE_VISIT = "city_page_visit",
  CATEGORY_PAGE_VISIT = "category_page_visit",
  HOTEL_PAGE_VISIT = "hotel_page_visit",
  HOTEL_BADGE_FILTER_APPLIED = "hotel_filter_badge_category_applied",
  ROOM_SELECTED = "room_selected",
  HOTEL_BOOKING_FREE_TRANSFER = "free_transfer_form_filled",
  SNAPPPAY_TERMS_VIEWED = "snapppay_terms_viewed",
  SNAPPPAY_TERMS_DECLINED = "snapppay_terms_declined",
  SNAPPPAY_TERMS_ACCEPTED = "snapppay_terms_accepted",
  SNAPPPAY_SELECTED = "snapppay_selected",
  USER_LOGGED_IN = "user_logged_in",
  LOGIN_OPENED = "login_opened",
  JEK_LOGIN = "jek_login",
  CREDENTIAL_ENTERED = "credential_entered",
  OTP_OPENED = "otp_opened",
  OTP_ENTERED = "otp_enterd",
  OTP_ENTERED_RESULT = "otp_entered_result",
  OTP_NOT_DELIVERED = "otp_not_delivered",
  CALL_CS = "callcs",
  MY_TRIPS_CLICKED = "my_trips_clicked",
  TRIP_DETAILS_OPENED = "trip_details-opened",
  TICKET_DOWNLOADED = "ticket_downloaded",
  BOOKING_CANCELLED = "booking_cancelled",

  VILLA_SEARCH_CITY_SELECTED = "villa_search_city_selected",
  VILLA_SEARCH_DATE_SELECTED = "villa_search_date_selected",
  VILLA_SEARCH_DATE_SKIPPED = "villa_search_date_skipped",
  VILLA_SEARCH_GUEST_SELECTED = "villa_search_guest_selected",
  VILLA_SEARCH_GUEST_SKIPPED = "villa_search_guest_skipped",
  VILLA_SEARCH_TIME_SPENT = "villa_search_time_spent",

  TOUR_ST_SEARCH = "Tour_ST_Search",
  TOUR_ST_CHANGE_PACKAGE = "Tour_ST_Change_Package",
  TOUR_ST_SELECT_SOLUTION = "Tour_ST_Select_Solution",
  TOUR_ST_HOTEL_DETAILS = "Tour_ST_Hotel_Details",
  TOUR_ST_HOTEL_DETAILS_LOCATION = "Tour_ST_Hotel_Details_Location",
  TOUR_ST_HOTEL_DETAILS_RATE_REVIEW = "Tour_ST_Hotel_Details_Rate&Review",
  TOUR_ST_HOTEL_DETAILS_FACILITIES = "Tour_ST_Hotel_Details_Facilities",
  TOUR_ST_TELESALES = "Tour_ST_TeleSales",
  CHANGE_ROOM_FLIGHT_BUTTON_CLICKED = "change_room_flight_button_clicked",
  CHANGE_ROOM_FLIGHT_PAGE_VISITED = "change_room_flight_page_visited",
  PASSENGERS_PAGE_VISITED = "passengers_page_visited",
  INFO_CONFIRMED = "info_confirmed",
  TOUR_HOTEL_SELECT_CLICKED = "Tour_Hotel_Select_Clicked",
  PRICING_TABLE_CLICKED = "pricing_table_clicked",

  VPN_PAGE_VISITED = "vpn_page_visited",
  // user tracking v2 events
  PAGE_VISIT_CITY = "city_page_visited",
  PAGE_VISIT_PROPERTY = "property_page_visited",
  DRAFT_INFO = "passengers_info_drafted",
  CONFIRM_INFO = "passengers_info_confirmed",
  PAGE_VISIT_AVAILABILITY_WAITING = "waiting_page_visited",
  VISIT_PRE_PAYMENT = "checkout_page_visited",
  VILLA_AMENITIES_MODAL_OPEN = "villa_amenities_modal_opened",
  VILLA_AMENITIES_MODAL_SCROLL_CHANGED = "villa_amenities_scroll_changed",
  REDEEM_DISCOUNT = "discount_redeemed",
  PAYMENT_ON = "payment_created",
  PAGE_VISIT_AFTER_PAYMENT = "thankyou_page_visited",
  ROOM_RESERVE_CARD_VIEWED = "room_card_viewed",
  ROOM_RESERVE_BUTTON_CLICKED = "room_reserve_button_clicked",
  ROOM_RESERVE_DETAIL_VIEWED = "room_detail_viewed",
  ROOM_RESERVE_NON_AVAILABLE_BUTTON_CLICKED = "room_reserve_non_available_button_clicked",
  HOTEL_CARD_VIEWED = "hotel_card_viewed",
  SEARCH_RESULTS_PAGE_VISITED = "search_results_page_visited",
  SOLUTION_DETAIL_CLICKED = "solution_detail_clicked",
  SOLUTION_SELECTED = "solution_selected",
  TOUR_PACKAGE_SHOW_MORE_CLICKED = "tour_package_show_more_clicked",
  PASSENGER_INFO_VISITED = "passengers_info_page_visited",
  PASSENGER_INFO_PAGE_BACK_BUTTON_CLICKED = "passengers_info_page_back_button_clicked",
  PASSENGERS_INFO_FAILED = "passengers_info_failed",
  REVIEW_FORM_LOADED = "review_form_loaded",
  REVIEW_FORM_SUBMITTED = "review_form_submitted",
  REVIEW_VIEWED = "review_viewed",
  FILTER_SELECTED = "filter_selected",
  REGION_PAGE_VISITED = "region_page_visited",
  RESERVE_BUTTON_CLICKED = "reserve_button_clicked",
  TIME_MS_SPENT = "time_ms_spent",
  HOTEL_RESERVE_BUTTON_CLICKED = "hotel_reserve_button_clicked",
  ROOM_PASSENGERS_INTERACTED = "room_passengers_interacted",
  SEARCH_BOX_INTERACTED = "search_box_interacted",
  TRIP_PURPOSE_CLICKED = "trip_purpose_clicked",
  PAYMENT_BLOCK_PAGE_VISITED = "payment_block_page_visited",
  PAYMENT_HELP_CLICKED = "payment_help_clicked",
  PAYMENT_HELP_MODAL_VISITED = "payment_help_modal_visited",
  PAYMENT_LINK_COPIED_CLICKED = "payment_link_copied_clicked",
  THIRD_PARTY_WALLETS_PAYMENT_REQUESTED = "third_party_wallets_payment_requested",
  THIRD_PARTY_WALLETS_REQUESTED = "third_party_wallets_requested",
  // Profile
  WALLET_CLICKED = "wallet_clicked",
  TRANSACTION_LIST_CLICKED = "transaction_list_clicked",
  CHARGE_WALLET_CLICKED = "charge_wallet_clicked",
  CHARGE_WALLET_REDIRECTED_TO_IPG = "charge_wallet_redirected_to_ipg",
  CHARGE_WALLET_RESULT = "charge_wallet_result",
  WALLET_WITHDRAW_CLICKED = "wallet_withdraw_clicked",
  WALLET_WITHDRAW_RULES_ACCEPTED = "wallet_withdraw_rules_accepted",
  WALLET_WITHDRAW_CARD_SELECTED = "wallet_withdraw_card_selected",
  WALLET_WITHDRAW_AMOUNT_AND_CARD_SELECTED = "wallet_withdraw_amount_and_card_selected",
  WALLET_WITHDRAW_REQUEST_CONFIRMED = "wallet_withdraw_request_confirmed",

  DL_TICKET_CLICKED = "dl_ticket_clicked",
  PURCHASE_TRACKING_CLICKED = "purchase_tracking_clicked",

  LOGIN_SNAPPPAY_CLICKED = "login_snapppay_clicked",
  DETAIL_SNAPPPAY_CLICKED = "detail_snapppay_clicked",
  MAP_LISTING_CARD_CLICKED = "map_listing_card_clicked",
  DATE_SELECTED = "date_selected",
  MAP_SEARCH_CLICKED = "map_search_clicked",
  MAP_SHOW_LIST_BUTTON_CLICKED = "show_list_button_clicked",
  MAP_TOGGLE_CLICKED = "map_toggle_clicked",
  MAP_AREA_CHANGED = "map_area_changed",
  MAP_VIEWED = "map_viewed",
  MAP_CARD_DETAIL_CLICKED = "map_card_detail_clicked",
  GATEWAY_CLICKED = "gateway_clicked",
  FILTER_PILL_REMOVED = "filter_pill_removed",

  // Auto reserve
  AUTO_RESERVE_CLICKED = "auto_reserve_clicked",
  AUTO_RESERVE_CONFIRM_RULES_CLICKED = "confirm_rules_clicked",
  AUTO_RESERVE_DEPARTURE_PAGE_VISITED = "departure_time_page_visited",
  AUTO_RESERVE_DEPATURE_TIME_SELECTED = "departure_time_selected",
  AUTO_RESERVE_PASSENGER_PAGE_VISITED = "auto_reserve_passengers_info_page_visited",
  AUTO_RESERVE_PASSENGER_INFO_CONFIRMED = "auto_reserve_passengers_info_confirmed",
  AUTO_RESEVER_CHECKOUT_PAGE_VISITED = "auto_reserve_checkout_page_visited",
  AUTO_RESERVE_THANKYOU_PAGE_VISITED = "auto_reserve_thankyou_page_visited",
  AUTO_RESERVE_PURCHASE_TRACKING_CLICKED = "auto_reserve_purchase_tracking_clicked",
  AUTO_RESERVE_LIST_VISITED = "auto_reserves_list_visited",
  AUTO_RESERVE_REMOVE_CLICKED = "auto_reserve_remove_clicked",
  AUTO_RESERVE_DETAIL_CLICKED = "auto_reserve_detail_clicked",
  AUTO_RESERVE_PAYMENT_CREATED = "auto_reserve_payment_created",

  TRAIN_MYTRIPS_CLICKS = "train_mytrips_clicked",
  BUS_MYTRIPS_CLICKS = "bus_mytrips_clicked",

  HOME_PAGE_VISITED = "home_page_visited",
  APP_DOWNLOAD_PAGE_VIEWD = "app_download_page_viewed",
  APP_DOWNLOAD_LINK_CLICKED = "app_download_link_clicked",
  GENERAL_SEARCH = "search_initiated",
  PAGE_VIEWED = "page_viewed",
  USER_SESSION_STARTED = "user_session_started",
  AI_SUGGESTION_REASON_VIEWED = "ai_suggestion_reason_viewed",
  AI_SUGGESTION_HOTEL_CARD_CLICKED = "ai_suggestion_hotel_card_clicked"
}

export enum DATA_LAYER_EVENTS {
  HOTEL_SEARCH = "hotel-search",
  HOTEL_INTERNATIONAL_SEARCH = "IH-search",
  BOOK_SUCCEED = "book_succeed",
  HOTEL_SUCCEED = "hotel_select",
  SOLUTION_SELECT = "solution_select",
  VIEW_ITEM_LIST = "view_item_list",
  SELECT_ITEM = "select_item",
  ADD_TO_CART = "add_to_cart",
  BEGIN_CHECKOUT = "begin_checkout",
  ADD_PAYMENT_INFO = "add_payment_info",
  PURCHASE = "purchase",
  GENERAL_SEARCH = "search_initiated",
  TOUR_SEARCH = "tour-search",
  TRAIN_SEARCH = "train-search",
  VILLA_SEARCH = "villa-search",
  BUS_SEARCH = "bus-search",
  BUS_INTL_SEARCH = "IB-search",
  VISA_SEARCH = "visa-search",
  FLIGHTS_SEARCH = "flights-search",
  FLIGHT_INTL_SEARCH = "IF-search",
  FLIGHTS_INTL_SEARCH_RESULTS_PAGE_VISITED = "results_page_visited",
  FLIGHTS_INTL_SOLUTION_DETAIL_CLICKED = "solution_detail_clicked",
  FLIGHTS_SOLUTION_SELECTED = "solution_selected",
  FLIGHTS_INTL_COLD_CALL_CLICKED = "cold_call_button_clicked",
  FLIGHTS_INTL_COLD_CALL_SUCCESS = "cold_call_submitted",
  FLIGHTS_INTL_PASSENGER_INFO_VISITED = "passengers_info_page_visited",
  FLIGHT_INTL_SEARCH_INITIATED = "intlFlightSearchInitiated",
  FLIGHT_INT_SEARCH_LANDED = "intlFlightSearchLanded",
  FLIGHT_INT_SELECT_SOLUTION = "intlFlightSelectedSolution",
  FLIGHT_INTL_VIEW_ITEM = "intflight_view_item",
  FLIGHT_INTL_BOOK_CLICK = "intflight_begin_checkout",
  CONFIRM_INFO = "passengers_info_confirmed",

  FLIGHT_DOM_SEARCH_INITIATED = "domFlightSearchInitiated",
  FLIGHT_DOM_SEARCH_LANDED = "domFlightSearchLanded",
  FLIGHT_DOM_VIEW_ITEM = "domflight_view_item",
  FLIGHT_DOM_BOOK_CLICK = "domflight_begin_checkout",

  SUBMIT_CIP = "CipRequest",
  TELESALES_BUTTON_CLICK = "coldcallclick",
  TELESALES_SUBMIT = "coldcallrequest",

  CHECKOUT_PAGE_VISITED = "checkout_page_visited",
  CHECKOUT_PURCHASE_FAILED = "purchase_failed",
  CHECKOUT_PAYMENT_FAILED = "payment_failed",
  CHECKOUT_PAYMENT_SUCCEED = "payment_succeed",
  CHECKOUT_PAYMENT_CREATED = "payment_created",
  FORCE_LOGIN_CONFIRMED = "force_login_confirmed",
  FORCE_LOGIN_SUBMITTED = "force_login_submitted"
}
